module.exports = __webpack_public_path__ + "img/sc_billy.fcf7ba70.png";